import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Menu,
  MenuButton,
  MenuItem,
  MenuItems,
  Transition,
} from "@headlessui/react";
import { Fragment } from "react";
import { usePopper } from "react-popper";
import { bottom, top, left, right } from "@popperjs/core";
import { classNames } from "../../helpers/classNames";

const Dropdown = ({
  data = [],
  label,
  labelClasses,
  buttonClasses,
  buttonLabelClasses,
  buttonIcon,
  buttonIconPosition,
  buttonLabel,
  dropdownContainer,
  headerdropdownlabel,
  headerlabelicon,
  headerlabel,
  xPlacement = "left",
  buttonArrowIconClasses,
  buttonArrowIcon = "fa-regular fa-chevron-down",
  button,
  onChange = () => {},
}) => {
  const popperElRef = useRef(null);
  const [targetElement, setTargetElement] = useState(null);
  const [popperElement, setPopperElement] = useState(null);

  const placements = {
    bottom: bottom,
    bottomLeft: "bottom-start",
    bottomRight: "bottom-end",
    top: top,
    topLeft: "top-start",
    topRight: "top-end",
    right: right,
    left: left,
    "": bottom,
  };

  const { styles, attributes } = usePopper(targetElement, popperElement, {
    placement: placements[xPlacement || ""],
    modifiers: [
      {
        name: "offset",
        options: {
          offset: [0, 0],
        },
      },
    ],
  });

  return (
    <>
      <Menu as="div" className="relative text-left">
        <div className="relative space-y-1 w-full">
          {label && <div className={classNames("text-sm font-semibold text-opplio-gray tracking-none", labelClasses)}>{label}</div>}
          <div className="relative w-full">
            <MenuButton
              ref={setTargetElement}
              className={classNames("flex items-center justify-center space-x-2 h-10 border border-opplio-border px-3 pr-8 rounded-md transition-all duration-200", buttonClasses)}
            >
              {button ? (
                button
              ) : (
                <>
                  {buttonIconPosition === "left" && <i className={classNames("fa-fw", buttonIcon)}></i>}
                  {buttonLabel && <div className={classNames("text-base font-medium block !leading-none", buttonLabelClasses)}>{buttonLabel}</div>}
                  {buttonIconPosition === "right" && <i className={classNames("fa-fw", buttonIcon)}></i>}
                  {buttonArrowIcon && (
                    <div className={classNames("absolute top-1/2 right-1 -translate-y-1/2", buttonArrowIconClasses)}>
                      <i className={classNames("fa-fw", buttonArrowIcon)}></i>
                    </div>
                  )}
                </>
              )}
            </MenuButton>
          </div>
        </div>
        <Transition
          as={Fragment}
          className="z-50"
          enter="transition ease-out duration-100"
          enterFrom="transform opacity-0 scale-95"
          enterTo="transform opacity-100 scale-100"
          leave="transition ease-in duration-75"
          leaveFrom="transform opacity-100 scale-100"
          leaveTo="transform opacity-0 scale-95"
          beforeEnter={() => setPopperElement(popperElRef.current)}
          afterLeave={() => setPopperElement(null)}
          ref={popperElRef}
          style={styles.popper}
          {...attributes.popper}
        >
          <MenuItems
            className={classNames(
              "absolute mt-1 border-b-2 border-chestnut-rose w-56 origin-top-right rounded-md bg-white shadow-lg focus:outline-none py-1 after:absolute after:content after:w-0 after:h-0 after:border-t-[16px] after:border-t-transparent after:border-r-[26px] after:border-r-white after:border-b-[12px] after:border-b-transparent after:top-[-10px] after:right-[4px] after:transform after:rotate-[94deg] after:rounded-2xl after:-z-10",
              dropdownContainer
            )}
          >
            <div className="">
              {data.length > 0 &&
                data.map((item, i) => (
                  <React.Fragment key={item?._id || i}>
                    {item?.link ? (
                      <MenuItem>
                        {({ active }) => (
                          <Link
                            to={item?.link}
                            className={classNames(
                              "group flex w-full items-center px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                              active ? "bg-opplio-veryLightBlue text-opplio-blue" : "text-opplio-grayB",
                              item?.class
                            )}
                          >
                            {item?.icon && <i className={classNames("fa-fw", item?.icon)}></i>}
                            <span>{item?.name}</span>
                          </Link>
                        )}
                      </MenuItem>
                    ) : (
                      <MenuItem>
                        {({ active }) => (
                          <button
                            type="button"
                            className={classNames(
                              "group flex w-full items-center text-blue-zodiac px-3 py-1.5 text-sm gap-2 transition-all duration-200",
                              active ? (item?.standout ? "bg-chestnut-rose/20 text-chestnut-rose" : "bg-shades-04") : "",
                              item?.class,
                              headerdropdownlabel
                            )}
                            onClick={item?.click && typeof item?.click === "function" ? item?.click : onChange}
                          >
                            {item?.icon && (
                              <span className={classNames("flex items-center justify-center", headerlabelicon)}>
                                <i className={classNames("fa-fw", item?.icon)}></i>
                              </span>
                            )}
                            <span className={classNames("text-base", headerlabel)}>{item?.name}</span>
                            <span className="flex justify-end ml-auto">
                              <i className="fa-regular fa-angle-right"></i>
                            </span>
                          </button>
                        )}
                      </MenuItem>
                    )}
                  </React.Fragment>
                ))}
            </div>
          </MenuItems>
        </Transition>
      </Menu>
    </>
  );
};

export default Dropdown;
